import React, { useState } from "react";
import { useDispatch } from "react-redux";
import _ from "lodash";

import Loader from "../loader";
import {
  getExecutiveEmployeeList,
  updateLeadStatus,
} from "../../actionCreator/leadListingActionCreater";
import KanbanView from "./KanbanView";
import FeatureComingSoon from "../../common/FeatureComingSoon";
import { useAlert } from "../../context/AlertProvider";

const LeadKanbanView = ({
  calendarShow,
  checkPageLayout,
  loading,
  rowSelection,
  getDetails,
  executiveEmployeeList,
  paginationValue,
  companyFilterList,
  onPageChange,
}) => {
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const [draggableLead, setDraggableLead] = useState({});
  const [leads, setLeads] = useState([]);

  const updateLead = async (payload) => {
    const res = await dispatch(updateLeadStatus(payload));
    if (res?.response?.status === 403) {
      showAlert(
        "warning",
        "Permission Denied",
        "You do not have permission to update lead status."
      );
      setLeads(leads?.length ? leads : executiveEmployeeList);
      return;
    }
    if (
      res.response &&
      res.response.status >= 400 &&
      res.response.status <= 500
    ) {
      showAlert("error", "Something went wrong. Please try again.");
    }
  };

  const onStatusUpdate = (obj) => {
    const newPayload = _.cloneDeep(
      leads?.length ? leads : executiveEmployeeList
    );
    const updatedPayload = newPayload?.map((d) => {
      if (d.executiveData.statusId === draggableLead?.status) {
        return {
          ...d,
          executiveData: {
            ...d.executiveData,
            leadsList: d.executiveData?.leadsList?.filter(
              (i) => i.id !== obj.id
            ),
          },
        };
      } else {
        if (d.executiveData.statusId === obj?.status) {
          return {
            ...d,
            leadsList: [...d.executiveData?.leadsList, obj],
          };
        } else {
          return d;
        }
      }
    });
    updateLead(obj);

    setLeads(updatedPayload);
  };

  const dropEvent = async (obj) => {
    const newPayload = _.cloneDeep(
      leads?.length ? leads : executiveEmployeeList
    );
    newPayload.forEach(async (item) => {
      if (item.executiveData.statusId === draggableLead.status) {
        const filterList = item.executiveData.leadsList.filter(
          (it) => it.id !== draggableLead.id
        );
        item.executiveData.totalRecords = filterList.length;
        item.executiveData.leadsList = filterList;
      }
      if (item.executiveData.statusId === obj.statusId) {
        let payload = _.cloneDeep(draggableLead);
        payload.status = obj.statusId;
        item.executiveData.leadsList.push(payload);
        item.executiveData.totalRecords = item.executiveData.leadsList.length;
        payload.customLayout = "1";
        updateLead(payload);
      }
      setLeads(newPayload);
    });
  };

  const dragStartEvent = (e, obj, obj1) => {
    setDraggableLead(obj);
  };

  return (
    <>
      {!loading ? (
        <div id="kanban" className="container-fluid">
          <div className="card-header col-xl-12 col-lg-10 card  shadow col-kanban ">
            <span className="ml-4 fs-23 mr-3">
              <i className=" las la-calendar" onClick={calendarShow}></i>
              <i
                className=" btn  mr-3 ml-3 kanbanlist"
                onClick={() => checkPageLayout(1)}
              ></i>
              <i
                className=" btn  kanbanview"
                onClick={() => checkPageLayout(2)}
              ></i>
            </span>

            <span className="kanspan">
              <div className="buttons-container textsearch">
                <ul className="d-flex mt-1  m-mt">
                  <li>
                    <a
                      className=" mr-2"
                      href="#"
                      id=""
                      role="button"
                      data-toggle=""
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i
                        className="right-icons las la-tags"
                        aria-hidden="true"
                      ></i>
                    </a>
                  </li>
                  <li>
                    <a
                      className=" mr-2"
                      href="#"
                      id=""
                      role="button"
                      data-toggle=""
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i
                        className="right-icons la la-file-excel"
                        aria-hidden="true"
                      ></i>
                    </a>
                  </li>
                  <li>
                    <a
                      className=" mr-2"
                      role="button"
                      data-toggle=""
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i
                        className="right-icons la la-file-pdf"
                        aria-hidden="true"
                      ></i>
                    </a>
                  </li>
                  <li>
                    <a
                      className=" mr-2"
                      role="button"
                      data-toggle=""
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i
                        className="right-icons la la-print"
                        aria-hidden="true"
                      ></i>
                    </a>
                  </li>
                </ul>
                <FeatureComingSoon>
                  <button
                    type="button"
                    className="ant-btn css-1mqg3i0 ant-btn-default d-none d-sm-inline-block ml-2 btn-outline-grey"
                  >
                    <i className="fas fa-bolt pr-1"></i>
                    <span> CONNECT TO CRM</span>
                  </button>
                </FeatureComingSoon>
              </div>
            </span>
          </div>
          <div className="mt30">
            <KanbanView
              localExecutiveEmployeeList={
                leads?.length ? leads : executiveEmployeeList
              }
              dragStartEvent={dragStartEvent}
              dropEvent={dropEvent}
              draggableLead={draggableLead}
              updateLead={onStatusUpdate}
            />
          </div>
        </div>
      ) : (
        <div id="kanban" className="container-fluid">
          <Loader />
        </div>
      )}
    </>
  );
};

export default LeadKanbanView;
